import { useCallback } from 'react'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './SettingsButton.styled'

export const useSettingsButton = ({ className, label }) => {
	const classes = useStyles()
	const { setLeadFormModalActive } = PageBuilderSelector.useActions()

	const handleClick = useCallback(
		event => {
			event.preventDefault()
			event.stopPropagation()
			setLeadFormModalActive(true)
		},
		[setLeadFormModalActive],
	)

	return [
		{
			className,
			classes,
			label,
		},
		{
			handleClick,
		},
	]
}
